/**
 * Offer outgoing layout: simple sheet vs full document builder.
 *
 * Authoritative signal: API `offer.layout` (`simple` | `document`), derived from
 * whether `offers.document_structure` is persisted (nil → simple).
 */
export function resolveOfferLayout(offer) {
  const layout = offer?.layout;
  if (layout === "document" || layout === "simple") return layout;
  return "simple";
}

export function isSimpleOfferLayout(offer) {
  return resolveOfferLayout(offer) === "simple";
}

export function isDocumentOfferLayout(offer) {
  return resolveOfferLayout(offer) === "document";
}

/** The other outgoing layout — used only as a secondary/advanced print option. */
export function alternateOfferLayout(offer) {
  return resolveOfferLayout(offer) === "document" ? "simple" : "document";
}
